const BASE_URL = {
  BASE_URL: process.env.REACT_APP_API_URL,
  BASE_URL_CLIENT: process.env.REACT_APP_CLIENT_API_URI,
};
export default BASE_URL;
